export default __webpack_public_path__ + "static/exp1-78044bd1d82c96708a93173566975df6.webp";